function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalogue1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 308,
    viewBox: "0 0 240 308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9355"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9193",
    transform: "translate(-934 -1750)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8604",
    width: 110,
    height: 144,
    rx: 16,
    transform: "translate(936 1825)",
    style: {
      fill: "#e1e4e8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8601",
    width: 110,
    height: 144,
    rx: 16,
    transform: "translate(934 1823)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9192"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45750",
    d: "M-3016.465 372.059H-3029v-47.981h17.681c.029.155-.1.177-.193.209a2.132 2.132 0 0 0-1.5 1.768.319.319 0 0 1-.064.122c-.54.373-1.152.614-1.719.94a19.659 19.659 0 0 0-8.73 10.2 18.667 18.667 0 0 0-1.252 5.734c-.027.466-.088.93-.072 1.4a2.576 2.576 0 0 0 2.24 2.483 15.234 15.234 0 0 0 1.957.082c.578.013.65.082.664.645.007.281-.007.562.02.843q.022 7.833 0 15.664a28.767 28.767 0 0 0 .082 4.1 4.133 4.133 0 0 0 2.8 3.423c.222.075.541.032.621.368z",
    transform: "translate(3994 1522.931)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45751",
    d: "M-2767.959 324.009q8.513 0 17.026-.009c.32 0 .383.063.383.384q-.015 23.616 0 47.232c0 .321-.062.385-.383.384-4.054-.014-8.108-.009-12.161-.009.009-.226.206-.2.34-.244a4.341 4.341 0 0 0 3.27-4.416c0-1.077.013-2.153-.01-3.231-.013-5.284-.024-10.568 0-15.851a4.492 4.492 0 0 1 .052-1.1c.128-.247.366-.2.577-.205a17.034 17.034 0 0 0 2.006-.084 2.55 2.55 0 0 0 2.239-2.531 18.606 18.606 0 0 0-.335-3.581 19.789 19.789 0 0 0-5.77-10.756 19.14 19.14 0 0 0-4.912-3.464 2.265 2.265 0 0 1-.566-.324.961.961 0 0 1-.129-.395 2.188 2.188 0 0 0-1.3-1.542c-.125-.057-.332-.028-.327-.258z",
    transform: "translate(3763.55 1523)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45752",
    d: "M-2949.476 673.7a7.528 7.528 0 0 0-1.108-.428 4.406 4.406 0 0 1-2.521-4.045c-.034-1.1 0-2.208 0-3.312.273-.219.6-.142.9-.142q11.633-.007 23.266 0h2.289a1.77 1.77 0 0 1 .646.068c.219.112.223.323.225.525.008 1.09.079 2.187-.017 3.269a4.395 4.395 0 0 1-2.768 3.849 7.371 7.371 0 0 1-1.272.219z",
    transform: "translate(3927.012 1221.293)",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45753",
    d: "M-2879.562 324.078a2.352 2.352 0 0 1 1.792 2.15c.257.571-.089.992-.354 1.433a2.3 2.3 0 0 1-1.93.962q-5.976.008-11.951 0a2.288 2.288 0 0 1-1.938-.947c-.274-.475-.6-.94-.336-1.534a2.312 2.312 0 0 1 1.807-2.06z",
    transform: "translate(3875.153 1522.931)",
    style: {
      fill: "#f84a46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45754",
    d: "M-2754.387 673.708a9.976 9.976 0 0 0 1.533-.479 4.312 4.312 0 0 0 2.39-3.878c.034-1.136.009-2.274.01-3.411l.063-.065a8.476 8.476 0 0 1 2.067-.085 1.261 1.261 0 0 1 .935.141 33.171 33.171 0 0 1-.064 4.012 4.333 4.333 0 0 1-3.463 3.676c-.073.015-.158 0-.2.089z",
    transform: "translate(3751.568 1221.283)",
    style: {
      fill: "#545454"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45755",
    d: "M-2925.908 546.128c-.218 0-.436-.012-.654-.012l-26.549-.006c-.007-.124-.02-.248-.02-.372v-15.2c0-.124.012-.248.019-.372a.426.426 0 0 1 .165-.088 3.641 3.641 0 0 1 .652-.025h25.516c1 0 1.019.014 1.019 1.015v14.185c0 .289.067.6-.154.852z",
    transform: "translate(3927.022 1341.095)",
    style: {
      fill: "#f84a46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45756",
    d: "M-2989.659 363.853h-.074c0-.031-.006-.062-.01-.093-.042-.367.169-.855-.1-1.07-.221-.179-.685-.054-1.042-.065-.436-.014-.874 0-1.306-.047a2.616 2.616 0 0 1-2.428-2.712 19.868 19.868 0 0 1 3.355-11.027 19.61 19.61 0 0 1 8.489-7.179 2.39 2.39 0 0 0 .375 1.382.61.61 0 0 1-.348.292 18.2 18.2 0 0 0-8.068 7.734 18 18 0 0 0-2.2 7.479 9.766 9.766 0 0 0-.073 1.305 1.163 1.163 0 0 0 1.064 1.213 10.712 10.712 0 0 0 1.818.052c.281 0 .323-.187.324-.41v-1.592c0-.2-.029-.413.165-.56a.491.491 0 0 1 .163-.052c.2-.02.406-.013.608-.013h25.6a1.457 1.457 0 0 1 .822.1.7.7 0 0 1 .135.481q.016 2.114 0 4.229a.716.716 0 0 1-.126.484 1.48 1.48 0 0 1-.555.035h-26.035a1.658 1.658 0 0 0-.553.034z",
    transform: "translate(3963.644 1507.412)",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45757",
    d: "M-2952.329 529.208c.168-.125.362-.065.543-.065h25.98c.2 0 .4-.008.607-.011.024-.019.046-.051.073-.055a10.049 10.049 0 0 1 2.882-.014c.046.006.074.053.109.083.006.5.017 1 .017 1.5v13.957c0 .187-.011.374-.017.561l-3.072-.013c0-5.153 0-10.306.015-15.459 0-.437-.184-.465-.529-.464q-13 .01-26 0c-.203-.004-.406-.015-.608-.02z",
    transform: "translate(3926.314 1342.058)",
    style: {
      fill: "#c33b3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45758",
    d: "M-2756.053 343.757a2.678 2.678 0 0 0 .4-1.331 19.249 19.249 0 0 1 6.973 5.3 19.968 19.968 0 0 1 4.488 9.977 19.608 19.608 0 0 1 .211 2.612 2.71 2.71 0 0 1-2.851 2.986c-.669.017-1.339.018-2.008.026a2 2 0 0 1-.084-1.316c.127-.247.365-.2.575-.206.529-.019 1.06.035 1.586-.029a1.215 1.215 0 0 0 1.257-1.421 18.487 18.487 0 0 0-.463-3.843 18.365 18.365 0 0 0-3.871-7.8 17.959 17.959 0 0 0-5.816-4.605c-.163-.079-.371-.115-.397-.35z",
    transform: "translate(3753.039 1506.733)",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45759",
    d: "m-2717.725 487.937-.017 1.43-.018 1.14-3.063-.013v-5.133a.416.416 0 0 1 .374-.145c.773-.012 1.547 0 2.321-.016a.642.642 0 0 1 .4.109.565.565 0 0 1 .13.387 32.53 32.53 0 0 1 0 1.9.485.485 0 0 1-.127.341z",
    transform: "translate(3721.937 1380.691)",
    style: {
      fill: "#545454"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45760",
    d: "m-2948.854 371.629-.022-2.6c.162-.164.373-.131.572-.138.3-.01.591.01.886-.015a.611.611 0 0 0 .636-.616c.035-.981.042-1.963 0-2.943-.019-.4-.277-.606-.788-.628a10.049 10.049 0 0 0-2.188.057 6.125 6.125 0 0 1-.887.027h-29.388c-1.158 0-1.237.081-1.238 1.26 0 .624-.006 1.248 0 1.872.01.772.195.94.977.975.379.017.782-.113 1.131.149 0 .749-.011 1.5 0 2.247 0 .26-.069.36-.341.352-.591-.018-1.185.011-1.776-.011a1.253 1.253 0 0 1-1.352-1.345c.3-7.675 3.836-13.286 10.682-16.781a1.018 1.018 0 0 1 .132-.046 2.4 2.4 0 0 0 2.067.966c3.829-.011 7.657-.017 11.486 0a2.624 2.624 0 0 0 2.184-.931 18.682 18.682 0 0 1 6.605 5.248 18.556 18.556 0 0 1 4.059 11.565 1.265 1.265 0 0 1-1.38 1.321c-.685.03-1.371.015-2.057.015z",
    transform: "translate(3953.067 1496.999)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45761",
    d: "M-2854.25 564.211a5.634 5.634 0 0 1 .924-2.661 21.762 21.762 0 0 1 1.989-2.935c.452-.569.853-.581 1.287-.013a18.156 18.156 0 0 1 2.726 4.5 3.54 3.54 0 0 1-3.031 4.6 3.6 3.6 0 0 1-3.895-3.491z",
    transform: "translate(3839.728 1316.262)",
    style: {
      fill: "#feba33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45762",
    d: "M-2970.084 453.2c-.451 0-.9 0-1.355-.006-.657-.013-.9-.26-.9-.911 0-.889-.006-1.779 0-2.668a.725.725 0 0 1 .828-.826h30.746c.047 0 .094 0 .14.007a.729.729 0 0 1 .148.572c.007 1.046.01 2.092 0 3.139-.006.612-.048.643-.679.643h-28.292a1.32 1.32 0 0 0-.554.039l-.038.01z",
    transform: "translate(3943.986 1412.84)",
    style: {
      fill: "#cbcbcb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45763",
    d: "M-2952.368 452.493c.177-.153.389-.081.584-.081q14.1-.006 28.191 0c.6 0 .6 0 .6-.61v-3.7a8.427 8.427 0 0 1 2.492-.015.668.668 0 0 1 .6.76v2.845a.724.724 0 0 1-.807.806c-.481.01-.962 0-1.443.005l-3.077.018c-.2-.005-.4-.015-.606-.015h-25.921c-.208-.006-.411-.006-.613-.013z",
    transform: "translate(3926.348 1413.532)",
    style: {
      fill: "#aeaeae"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8602",
    width: 62,
    height: 8,
    rx: 4,
    transform: "translate(946 1919)",
    style: {
      fill: "#9da7b2",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8603",
    width: 86,
    height: 8,
    rx: 4,
    transform: "translate(946 1935)",
    style: {
      fill: "#9da7b2",
      opacity: 0.3
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9194",
    transform: "translate(-806 -1823)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8604",
    width: 110,
    height: 144,
    rx: 16,
    transform: "translate(936 1825)",
    style: {
      fill: "#e1e4e8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8601",
    width: 110,
    height: 144,
    rx: 16,
    transform: "translate(934 1823)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8602",
    width: 62,
    height: 8,
    rx: 4,
    transform: "translate(946 1919)",
    style: {
      fill: "#9da7b2",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8603",
    width: 86,
    height: 8,
    rx: 4,
    transform: "translate(946 1935)",
    style: {
      fill: "#9da7b2",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9195"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45694",
    d: "M-2689.008 980q0 11.782.008 23.563c0 .336-.052.439-.421.439q-23.588-.017-47.177 0c-.348 0-.4-.084-.4-.411q.014-23.586 0-47.173c0-.315.037-.416.4-.416q23.612.019 47.224 0c.328 0 .379.075.379.387q-.021 11.804-.013 23.611z",
    style: {
      fill: "#fefefe"
    },
    transform: "translate(3702 891)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45695",
    d: "M-2683.59 999.221c1.311.744 2.625 1.481 3.931 2.233q5.4 3.107 10.785 6.226c.144.083.317.131.414.286.033.206-.134.262-.262.338-2.927 1.75-5.9 3.413-8.85 5.131-3.054 1.781-6.141 3.5-9.178 5.313-2.461 1.466-4.99 2.815-7.422 4.33a1.383 1.383 0 0 1-.469.205.782.782 0 0 1-.522-.162q-4.038-2.341-8.08-4.673-2.629-1.509-5.273-2.993c-.312-.175-.609-.374-.93-.535-.162-.081-.335-.186-.32-.417a.6.6 0 0 1 .349-.356c1.5-.834 2.962-1.717 4.444-2.574q2.283-1.321 4.56-2.652 3.145-1.837 6.3-3.659 1.837-1.066 3.666-2.148a118.66 118.66 0 0 1 2.953-1.7c1.171-.65 2.3-1.38 3.483-2a1.326 1.326 0 0 1 .421-.193z",
    transform: "translate(3678.171 853.182)",
    style: {
      fill: "#f0c30f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45696",
    d: "M-2588.814 1084.412c1.571-.912 3.131-1.845 4.717-2.73 2.182-1.217 4.3-2.549 6.476-3.768 2.833-1.584 5.625-3.24 8.434-4.867q3.177-1.84 6.351-3.686a1.36 1.36 0 0 0 .2-.181 4.631 4.631 0 0 1 2.252 3.256 2.617 2.617 0 0 1 .049.971 1.591 1.591 0 0 1-.856 1.25c-.828.459-1.642.944-2.46 1.422-.144.085-.317.133-.413.288a4.815 4.815 0 0 1-1.163.762q-4.807 2.795-9.616 5.585c-3.867 2.242-7.725 4.5-11.6 6.735a.652.652 0 0 1-.432.148c-.14-.061-.118-.179-.072-.275a3.23 3.23 0 0 0-.266-2.814 5.035 5.035 0 0 0-1.346-1.7c-.111-.108-.301-.177-.255-.396z",
    transform: "translate(3572.343 791.967)",
    style: {
      fill: "#d5b118"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45697",
    d: "M-2562.862 1133.639a4.663 4.663 0 0 1 2.313 3.976 1.586 1.586 0 0 1-.888 1.524q-8.673 5.017-17.33 10.062-3.937 2.288-7.876 4.574c-.173.1-.356.185-.535.277-.018-.333.182-.616.211-.938a1 1 0 0 0-.01-.62 4.952 4.952 0 0 0-1.815-3.135c-.131-.106-.281-.2-.3-.394a.433.433 0 0 1 .256-.31c2.3-1.306 4.576-2.65 6.861-3.981q2.581-1.5 5.171-2.991c1.913-1.1 3.807-2.241 5.722-3.34 2.172-1.247 4.328-2.52 6.5-3.765a16.788 16.788 0 0 1 1.72-.939z",
    transform: "translate(3572.576 735.566)",
    style: {
      fill: "#d5b118"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45698",
    d: "M-2668.97 1127.551a6.729 6.729 0 0 1-1.6 1 452.382 452.382 0 0 1-5.976 3.5c-1.8 1.04-3.606 2.053-5.4 3.1-1.851 1.076-3.685 2.18-5.535 3.257-1.728 1.006-3.469 1.987-5.2 2.988-.829.479-1.646.979-2.469 1.469-.2.137-.361-.005-.513-.094-3.119-1.823-6.26-3.607-9.381-5.427-1.654-.965-3.324-1.9-4.975-2.874-.154-.091-.371-.132-.323-.391.188-.325.564-.368.844-.556a11.317 11.317 0 0 1 1.5-.858.629.629 0 0 1 .568.124c2.34 1.359 4.688 2.7 7.03 4.059 1.75 1.013 3.494 2.035 5.256 3.026a1.627 1.627 0 0 0 1.606.093c.115-.057.241-.05.356-.095l6.644-3.872c2.272-1.317 4.551-2.622 6.823-3.939 2.177-1.263 4.342-2.547 6.527-3.8.929-.532 1.817-1.137 2.8-1.579z",
    transform: "translate(3678.685 741.654)",
    style: {
      fill: "#f0c30f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45699",
    d: "M-2709.206 1132.68a1.642 1.642 0 0 1-1.994.118c-2.312-1.326-4.613-2.673-6.92-4.008q-2.756-1.6-5.518-3.183a.315.315 0 0 0-.347-.036 5.35 5.35 0 0 1-.88-.579 5.316 5.316 0 0 0-1.286-.812 4.907 4.907 0 0 1-2.476-3.734 1.622 1.622 0 0 1 .976-1.9c.541-.237.97.078 1.421.287.185.46.679.511 1.03.724 1.264.772 2.579 1.461 3.864 2.2 2.281 1.313 4.553 2.641 6.83 3.96q1.53.887 3.069 1.76a.893.893 0 0 0 .269.055 6.781 6.781 0 0 1 1.494 1.638 4.149 4.149 0 0 1 .662 2.871c-.047.225-.279.384-.194.639z",
    transform: "translate(3694.699 748.843)",
    style: {
      fill: "#e4bc13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45700",
    d: "M-2726.308 1183.622c.128.35.5.389.758.543 1.269.762 2.579 1.457 3.86 2.2 1.494.864 2.967 1.764 4.462 2.627 1.521.879 3.061 1.727 4.586 2.6a8.621 8.621 0 0 0 1.487.824 8.036 8.036 0 0 1 1.5 1.635 4.436 4.436 0 0 1 .651 1.919 1.039 1.039 0 0 1 0 .651 1.607 1.607 0 0 1-.282.9 1.6 1.6 0 0 1-2.03.031l-6.913-4q-3.943-2.276-7.888-4.548a4.9 4.9 0 0 1-2.495-3.74 1.654 1.654 0 0 1 .807-1.827 1.581 1.581 0 0 1 .788-.114 1.4 1.4 0 0 1 .709.299z",
    transform: "translate(3694.684 692.103)",
    style: {
      fill: "#e4bc13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45701",
    d: "M-2719.2 1012.455c-.363.145-.572-.3-.927-.236a1.72 1.72 0 0 1-.494-.051c1.43-.845 2.856-1.7 4.292-2.533l21.377-12.435a1.592 1.592 0 0 1 1.865-.022 21.882 21.882 0 0 1-2.34 1.419c-1.216.748-2.464 1.442-3.7 2.159q-2.169 1.261-4.337 2.524c-.9.523-1.792 1.054-2.692 1.574-1.664.961-3.334 1.911-4.995 2.877-1.983 1.153-3.95 2.332-5.941 3.47-.708.407-1.427.799-2.108 1.254z",
    transform: "translate(3687.67 855.225)",
    style: {
      fill: "#d5b118"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45702",
    d: "M-2718.451 1172.564a1.754 1.754 0 0 1-.658-.189c-.155-.15-.435.1-.551-.174l2.666-1.527c.34.122.7.207.88.579z",
    transform: "translate(3686.828 703.161)",
    style: {
      fill: "#d5b118"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45703",
    d: "M-2721.671 1182.892c.142.189.412-.025.552.174h-.839z",
    transform: "translate(3688.838 692.469)",
    style: {
      fill: "#e8cb50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45704",
    d: "M-2611.949 1051.75a3.375 3.375 0 0 1 2.1.659q3.832 2.23 7.673 4.446c.094.054.188.111.277.173a.827.827 0 0 1 0 1.506c-.962.6-1.951 1.162-2.931 1.736-1.1.646-2.2 1.292-3.306 1.929a3.087 3.087 0 0 1-3.241.06q-4.237-2.417-8.446-4.883c-.716-.417-.707-1.13.024-1.589.8-.5 1.632-.968 2.453-1.445 1.25-.728 2.506-1.448 3.753-2.182a2.631 2.631 0 0 1 1.644-.41z",
    transform: "translate(3599.929 807.23)",
    style: {
      fill: "#e64c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45705",
    d: "M-2571.559 1285.213v-.651a.537.537 0 0 1 0 .651z",
    transform: "translate(3557.239 603.509)",
    style: {
      fill: "#e1c444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45706",
    d: "M-2668.453 1157.77v1.63c-.277 0-.38-.124-.378-.367a91.75 91.75 0 0 0 0-1.963c0-.258.1-.241.278-.147a.741.741 0 0 1 .4.477c.154.519.342 1.028.549 1.637.185-.328.313-.584.47-.821.073-.11.069-.365.29-.28.188.072.45.124.454.4.008.7 0 1.4 0 2.1 0 .071.008.181-.106.157a.284.284 0 0 1-.257-.286v-1.601c-.3.221-.364.535-.544.765-.081.1-.086.308-.259.289s-.2-.214-.251-.358q-.292-.826-.581-1.652z",
    transform: "translate(3642.352 715.248)",
    style: {
      fill: "#484c58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45707",
    d: "M-2625.907 1183.915a.676.676 0 0 1-.551-.458c-.32-.67-.646-1.337-1.044-2-.02.386-.034.773-.061 1.158-.008.109.066.287-.1.307s-.232-.123-.232-.282v-2.228c.323 0 .4.212.5.407.345.713.69 1.424 1.106 2.135v-1.619c.312.026.4.166.392.41-.016.711-.01 1.426-.01 2.17z",
    transform: "translate(3606.535 694.642)",
    style: {
      fill: "#494c58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45708",
    d: "M-2683.667 1150.054c-.466-.27-.908-.528-1.353-.781a.31.31 0 0 1-.181-.3v-2.313l1.435.835a.233.233 0 0 1 .1.322c-.083.156-.191.013-.271-.029-.272-.143-.537-.3-.84-.473-.116.394-.091.666.3.828a4.872 4.872 0 0 1 .565.327.212.212 0 0 1 .1.28c-.075.171-.181.035-.264 0a3.514 3.514 0 0 0-.709-.355.58.58 0 0 0 .344.828c.214.089.4.239.609.344.192.093.249.225.165.487z",
    transform: "translate(3656.676 724.169)",
    style: {
      fill: "#4a4d57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45709",
    d: "M-2644.612 1170.215c.559.432 1.249.521 1.548 1.11l-.094.127-1.024-.567a.621.621 0 0 0 .357.872c.246.133.68.157.6.691l-.962-.528a.611.611 0 0 0 .362.871 4.9 4.9 0 0 1 .683.4.226.226 0 0 1 .084.291c-.079.16-.18.024-.27-.011-.029-.011-.052-.037-.08-.046a1.616 1.616 0 0 1-1.21-2.043 7.229 7.229 0 0 0 .006-1.167z",
    transform: "translate(3621.208 703.562)",
    style: {
      fill: "#494c58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45710",
    d: "M-2704.61 1140c.006-.833.479-1.12 1.121-.779a2.025 2.025 0 0 1 .772.731c.058.094.126.2.005.287-.147.112-.183-.04-.24-.118a1.3 1.3 0 0 0-.642-.522c-.323-.1-.548-.005-.609.363a1.381 1.381 0 0 0 1.206 1.528.293.293 0 0 1 .3.326c-.012.2-.221.186-.37.148a2.02 2.02 0 0 1-1.384-1.342 4.383 4.383 0 0 1-.159-.622z",
    transform: "translate(3673.659 730.801)",
    style: {
      fill: "#494d57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45711",
    d: "M-2608.76 1190.923c.56.406 1.255.587 1.683 1.121l-.1.131c-.027 0-.06.016-.081.005-.539-.271-.539-.272-.54.328v1.4c-.312 0-.382-.157-.377-.395.009-.467-.014-.935.011-1.4a.57.57 0 0 0-.372-.659c-.188-.079-.375-.19-.224-.531z",
    transform: "translate(3589.838 685.442)",
    style: {
      fill: "#4b4e57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45712",
    d: "M-2668.835 1220.84c1.02.444.762 1.5 1.274 2.175.145-.253.271-.5.424-.732.081-.122.094-.388.345-.269.185.087.414.145.409.44-.012.73 0 1.46-.069 2.2-.606-.523-.113-1.253-.384-1.9-.143.241-.271.476-.419.7-.09.134-.115.377-.313.361s-.21-.242-.265-.4a13.855 13.855 0 0 0-.635-1.6v1.643c-.273-.01-.373-.121-.371-.353.008-.735.004-1.464.004-2.265z",
    transform: "translate(3642.357 659.265)",
    style: {
      fill: "#484c58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45713",
    d: "M-2627.65 1247.666c-.324-.048-.323-.252-.321-.463 0-.575 0-1.15.009-1.725 0-.113-.07-.288.075-.329.17-.047.277.1.347.246.214.431.42.866.631 1.3a5.138 5.138 0 0 0 .558.952c0-.419-.009-.839.006-1.257 0-.109-.105-.321.127-.314.173.005.244.15.242.335-.007.728 0 1.455-.066 2.213-.778-.631-.933-1.644-1.529-2.494z",
    transform: "translate(3606.606 638.002)",
    style: {
      fill: "#494c58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45714",
    d: "M-2683.667 1215.35c-.467-.267-.921-.529-1.378-.786-.149-.084-.152-.217-.151-.36 0-.621.009-1.243 0-1.864 0-.279.086-.334.325-.19.345.209.7.408 1.046.609.134.077.245.2.169.337-.112.208-.239.005-.34-.044-.26-.128-.508-.282-.766-.428-.206.492.041.7.406.9.234.128.636.166.541.659l-.959-.518a.607.607 0 0 0 .375.873c.2.079.373.223.567.319s.26.249.165.493z",
    transform: "translate(3656.671 666.937)",
    style: {
      fill: "#4a4d57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45715",
    d: "M-2644.25 1235.517c.952.32 1.505.752 1.461 1.148l-1.031-.563c-.123.4-.075.675.313.828.172.067.32.192.486.277.147.075.236.2.159.337-.1.169-.209-.007-.306-.045-.227-.089-.4-.29-.663-.323a.577.577 0 0 0 .353.823 5.712 5.712 0 0 1 .687.4.217.217 0 0 1 .09.287c-.076.153-.184.048-.272 0-.365-.208-.726-.423-1.092-.628a.3.3 0 0 1-.187-.29c.004-.752.002-1.495.002-2.251z",
    transform: "translate(3620.845 646.423)",
    style: {
      fill: "#494c58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45716",
    d: "M-2704.608 1204.546c0-.745.482-1.037 1.121-.7a1.976 1.976 0 0 1 .744.689c.059.09.205.19.053.314s-.208-.037-.272-.128a1.42 1.42 0 0 0-.52-.457c-.4-.2-.676-.056-.723.38a1.389 1.389 0 0 0 1.222 1.474.286.286 0 0 1 .294.33c-.021.195-.238.183-.379.146a2.106 2.106 0 0 1-1.347-1.262 2.434 2.434 0 0 1-.193-.786z",
    transform: "translate(3673.657 674.257)",
    style: {
      fill: "#4a4d57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45717",
    d: "M-2608.793 1255.511a6.8 6.8 0 0 1 1.656 1.147c-.288.137-.419-.136-.687-.087v1.936c-.3-.019-.386-.156-.381-.4.011-.45-.016-.9.012-1.351a.628.628 0 0 0-.4-.737.321.321 0 0 1-.2-.508z",
    transform: "translate(3589.87 628.928)",
    style: {
      fill: "#4b4e57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45718",
    d: "M-2562.706 1086.143c-.246.039-.491.082-.737.115-.114.015-.255.116-.339-.029-.064-.111.065-.193.106-.288s.1-.191.159-.31c-.447-.127-.675.466-1.225.261.51-.3.942-.55 1.379-.794.152-.084.269.038.37.122.122.1 0 .193-.049.28-.069.136-.148.267-.243.438.54.134 1.065-.375 1.575.016-.594.524-1.262.839-1.566.717l.674-.424c.075-.147.002-.135-.104-.104z",
    transform: "translate(3551.274 778.065)",
    style: {
      fill: "#fdf9f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45719",
    d: "M-2535.247 1101.917c.465-.094.733-.573 1.342-.442-.51.3-.913.526-1.311.765a.275.275 0 0 1-.34 0c-.123-.086-.079-.182-.057-.288.05-.239.093-.479.147-.761a3.756 3.756 0 0 0-.861.433c-.105.053-.226.094-.285-.025s.088-.141.157-.183c.333-.2.667-.4 1.007-.586.258-.143.392-.051.356.238s-.098.547-.155.849z",
    transform: "translate(3526.672 764.33)",
    style: {
      fill: "#fdf9f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45720",
    d: "M-2547.222 1095.888c-.408-.05-.7-.366-1.154-.569.493-.286.912-.526 1.329-.773.177-.1.294.028.422.1.222.125.437.262.705.425-.5.262-.818-.61-1.279-.112.12.224.425.208.537.448-.406.225-.725-.612-1.155-.07l.66.421z",
    transform: "translate(3536.954 769.806)",
    style: {
      fill: "#fdf6f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45721",
    d: "M-2574.406 1080.666c-.545.061-.812-.363-1.294-.5l.87-.509c.664-.389.952-.339 1.535.281-.442.2-.733-.621-1.206-.154.117.209.4.224.546.437-.422.243-.742-.594-1.156-.081.151.229.475.245.705.526z",
    transform: "translate(3560.863 783.019)",
    style: {
      fill: "#fdf7f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45722",
    d: "M-2583.87 1074.064c-.075.038-.1.063-.129.064-.5.019-.983-.244-1.018-.555s.384-.619.935-.655a1.368 1.368 0 0 1 1.074.342c.073.068.187.174.089.272s-.22.057-.311-.066a.878.878 0 0 0-1.04-.284c-.18.05-.366.13-.373.357s.193.294.362.369c.118.051.276-.003.411.156z",
    transform: "translate(3569.016 788.7)",
    style: {
      fill: "#fdf7f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45723",
    d: "m-2520.777 1109.146 1.083-.65c-.029-.182-.229-.164-.282-.284a.18.18 0 0 1 .286-.066c.132.082.274.147.4.234.17.116.535.221.475.347-.13.275-.32-.094-.5-.075-.367.04-.624.323-.945.468-.147.069-.284.28-.517.026z",
    transform: "translate(3512.805 757.912)",
    style: {
      fill: "#fdf5f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45724",
    d: "M-2548.451 1093.088a.309.309 0 0 1 .331-.059c-.037.114-.133.137-.228.163z",
    transform: "translate(3537.02 771.12)",
    style: {
      fill: "#ee867c"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9196",
    transform: "translate(-806 -1661)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8604",
    width: 110,
    height: 144,
    rx: 16,
    transform: "translate(936 1825)",
    style: {
      fill: "#e1e4e8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8601",
    width: 110,
    height: 144,
    rx: 16,
    transform: "translate(934 1823)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8602",
    width: 62,
    height: 8,
    rx: 4,
    transform: "translate(946 1919)",
    style: {
      fill: "#9da7b2",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8603",
    width: 86,
    height: 8,
    rx: 4,
    transform: "translate(946 1935)",
    style: {
      fill: "#9da7b2",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9197"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45725",
    d: "M-2486.922 433.061q0 18.11.009 36.22c0 .351-.079.431-.43.431q-23.78-.015-47.561-.009v-32.612c.17-.023.2.12.249.223a2.271 2.271 0 0 0 2.448 1.434c.107-.007.216 0 .324 0a3.3 3.3 0 0 1 .819.094 3.774 3.774 0 0 1 2.943 2.889 3.971 3.971 0 0 1-.177 2.391c-1.117 3.065-2.255 6.122-3.334 9.2-.028.075-.046.153-.07.23a16.5 16.5 0 0 0-.806 5.2c-.014 1.311 0 2.621 0 3.932a3.61 3.61 0 0 0 .04.653 1.351 1.351 0 0 0 1.479 1.253c2.387.006 4.775 0 7.162 0h7.022a1.328 1.328 0 0 0 1.54-1.372q-.023-1.443 0-2.885c.016-.561.011-1.124.008-1.686a2.819 2.819 0 0 0-2.842-2.867c-1.2-.016-2.405 0-3.607 0a2.526 2.526 0 0 1-.742-.08 1.623 1.623 0 0 1-1.146-2.166c.3-.954.67-1.883 1.01-2.822.706-1.953 1.421-3.9 2.127-5.855a1.72 1.72 0 0 1 .331-.665.987.987 0 0 1 .587-.1h1.771a1.533 1.533 0 0 0 1.49-1q.594-1.342 1.155-2.7c.191-.386.347-.787.521-1.181.068-.153.111-.323.279-.408a1.74 1.74 0 0 1 .645-.062c1.21 0 2.421-.015 3.631 0a2.246 2.246 0 0 0 2.2-1.2 1.293 1.293 0 0 0 .191-.561.536.536 0 0 1 .24-.424 1.6 1.6 0 0 1 .643-.068c1.18 0 2.36.012 3.54-.005a3.1 3.1 0 0 0 2.7-1.282 3.439 3.439 0 0 0 .524-1.279c.041-.176.04-.378.241-.476a20.374 20.374 0 0 1 2.592-.059c.108 0 .216.01.324 0 .75-.015 1.5 0 2.251 0q1.537-.016 3.074 0a53.784 53.784 0 0 1 2.2.005 6.908 6.908 0 0 1 .785 0 2.605 2.605 0 0 0 1.62-.331z",
    transform: "translate(3499.913 1425.288)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45726",
    d: "M-2534.991 318.757c0-2.107.009-4.214-.009-6.321 0-.343.063-.436.426-.436q15.147.018 30.295.01 8.428 0 16.857-.01c.369 0 .423.1.422.439-.014 3.449-.008 6.9-.008 10.348a4.93 4.93 0 0 0-2.618-.324 13.668 13.668 0 0 0-1.163 0c-.741.006-1.481 0-2.222 0q-1.538.015-3.075 0c-.748.015-1.5.007-2.243 0a6.058 6.058 0 0 1-1.572-.077c-.172-.122-.174-.322-.219-.5a3 3 0 0 0-3.149-2.515c-1.233-.021-2.466-.005-3.7-.014a.943.943 0 0 1-.631-.118.938.938 0 0 1-.2-.467 2.122 2.122 0 0 0-2.081-1.638c-.2-.009-.406 0-.608 0h-20.636c-.234 0-.468.01-.7-.01a5.025 5.025 0 0 0-1.56.12 2.038 2.038 0 0 0-1.288 1.128c-.072.139-.069.37-.318.385z",
    style: {
      fill: "#fefefe"
    },
    transform: "translate(3500 1535)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45727",
    d: "M-2534.9 368.547a2.87 2.87 0 0 1 1.042-1.4 1.035 1.035 0 0 1 .456-.2c.205.222.146.5.146.759q.007 4.122 0 8.244a5.109 5.109 0 0 0 .015.608.757.757 0 0 0 .715.736 1.339 1.339 0 0 1 .634.133 1.936 1.936 0 0 1 0 1.507c-1.652.127-2.237-.214-3.015-1.758z",
    transform: "translate(3499.913 1485.211)",
    style: {
      fill: "#6f6571"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45728",
    d: "M-2063.268 421.976c.92 0 1.841.017 2.76-.01a1.037 1.037 0 0 1 .99.477v.562a1 1 0 0 1-.989.476c-.45-.031-.9-.008-1.355-.008a7.622 7.622 0 0 1-1.365-1.286.179.179 0 0 1-.041-.211z",
    transform: "translate(3072.509 1435.344)",
    style: {
      fill: "#ebe9eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45729",
    d: "M-2503.429 365.107c.2-.006.405-.018.607-.018H-2482c1.939 0 2.454.391 2.961 2.253a.626.626 0 0 1 .1.151c.113 1.23.036 2.463.044 3.694.025 1.1.009 2.2.008 3.3a.652.652 0 0 1-.152.519c-.133.306-.036.679-.276.954a17.033 17.033 0 0 0-1.217-.034h-22.013a1.384 1.384 0 0 1-.864-.128 1.06 1.06 0 0 1-.143-.672v-9.385a.964.964 0 0 1 .123-.634z",
    transform: "translate(3471.5 1486.889)",
    style: {
      fill: "#fedf7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45730",
    d: "M-2474.58 513.452c-1.125 3.087-2.258 6.172-3.372 9.263a1.536 1.536 0 0 0 1.566 2.172c1.232 0 2.465-.007 3.7 0a2.978 2.978 0 0 1 3.067 3.076c0 .5-.01 1-.017 1.5-.149.185-.361.164-.561.164-3.245 0-6.491.02-9.736-.005a2.544 2.544 0 0 1-2.77-2.821c0-.64.009-1.28 0-1.919a2.12 2.12 0 0 0-1.543-2.056.708.708 0 0 1-.41-.2c-.116-.331.068-.607.172-.894q1.408-3.893 2.832-7.781a9.178 9.178 0 0 0 .449-2.144 2.4 2.4 0 0 1 2.393-2.294c1.714-.06 3.431-.02 5.147-.013a.484.484 0 0 1 .423.155.646.646 0 0 1-.026.541c-.354.978-.7 1.96-1.068 2.932a.568.568 0 0 1-.246.324z",
    transform: "translate(3454.415 1356.039)",
    style: {
      fill: "#fecf64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45731",
    d: "M-2500.031 647.29a2.483 2.483 0 0 1 1.693 1.05 2.245 2.245 0 0 1 .38 1.232c-.007.7 0 1.406 0 2.108a2.325 2.325 0 0 0 2.474 2.508c3.482.014 6.965 0 10.447 0v3.025a.792.792 0 0 1-.577.137c-3.529 0-7.058.021-10.586-.005a5.019 5.019 0 0 1-4.911-4.967 14.058 14.058 0 0 1 .625-4.29c.167-.549.146-.563-.443-.578-.259-.007-.536.064-.763-.133l.034-.1a1.89 1.89 0 0 1 1.627.013z",
    transform: "translate(3469.814 1231.316)",
    style: {
      fill: "#847e86"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45732",
    d: "M-2509.926 649.9c.374 0 .75.018 1.122-.008s.463.06.333.435a13.808 13.808 0 0 0-.74 4.618 4.929 4.929 0 0 0 3.976 4.7 6.238 6.238 0 0 0 1.112.092h10.854a1.448 1.448 0 0 1-1.575 1.517q-4.657.009-9.314 0h-4.961a1.5 1.5 0 0 1-1.64-1.627c.009-2.012-.078-4.025.06-6.035a13.437 13.437 0 0 1 .773-3.692z",
    transform: "translate(3478.049 1228.792)",
    style: {
      fill: "#6f6571"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45733",
    d: "m-2499.7 508-1.626-.013q1.486-4.112 2.969-8.226a8.744 8.744 0 0 0 .635-2.048 3.754 3.754 0 0 0-2.9-4.08c.039-.208.215-.195.361-.217a3.008 3.008 0 0 1 .466-.014h11.3a2.416 2.416 0 0 1 .649.046c.26.087.193.282.131.453-.116.317-.218.639-.353.949-.075.119-.091.294-.28.311-.13-.167-.315-.105-.479-.106q-2.434-.006-4.868 0a2.268 2.268 0 0 0-2.436 2.219 13.6 13.6 0 0 1-.99 3.577c-.69 1.933-1.406 3.856-2.109 5.785-.165.448-.315.906-.47 1.364z",
    transform: "translate(3469.486 1370.609)",
    style: {
      fill: "#fec150"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45734",
    d: "M-2489.1 480.251h-12.432c-.165 0-.345-.06-.491.077l-.835-.1-.011-1.475.031-.032.039.022 18.074.008h5.572c.164 0 .4-.1.457.182a2.156 2.156 0 0 1-2.075 1.31c-1.522.017-3.044.012-4.566.016a.789.789 0 0 1-.486.136c-.934.006-1.868.009-2.8 0a.6.6 0 0 1-.477-.144z",
    transform: "translate(3470.882 1383.909)",
    style: {
      fill: "#fecf64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45735",
    d: "M-2242.072 432.392v-3.825a2.31 2.31 0 0 1 1.433-.08.29.29 0 0 1 .128.11 1.67 1.67 0 0 1 .082.688 1.359 1.359 0 0 0 1.392 1.386c1.089.02 2.178 0 3.267.006a2.124 2.124 0 0 1 .511.029c.153.038.321.079.226.306a2.929 2.929 0 0 1-2.6 1.377c-1.479.036-2.96.005-4.439.003z",
    transform: "translate(3234.534 1429.501)",
    style: {
      fill: "#b5b0b6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45736",
    d: "m-2375.462 509.327.175-.3c.976.077 1.953.022 2.93.043.227 0 .472-.041.657.154-.421 1-.816 2.015-1.273 3a1.426 1.426 0 0 1-1.363.826c-.809.007-1.618 0-2.427 0 .391-1.077.784-2.154 1.171-3.232.056-.159.087-.327.13-.491z",
    transform: "translate(3356.599 1356.441)",
    style: {
      fill: "#857e86"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45737",
    d: "M-2220.493 431.031c-.057-.281-.283-.192-.451-.192-1.181-.006-2.363 0-3.544 0a1.468 1.468 0 0 1-1.542-1.549v-.7a.78.78 0 0 1 .614-.15q2.442-.008 4.885 0a1.033 1.033 0 0 1 .586.108.633.633 0 0 1 .013.795 3.106 3.106 0 0 1-.561 1.688z",
    transform: "translate(3219.997 1429.483)",
    style: {
      fill: "#c7c4c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45738",
    d: "M-2357.425 496.549c-1.043 0-2.087 0-3.13-.013-.166 0-.4.1-.456-.184l.471-1.312 3.763.012a10.8 10.8 0 0 1-.648 1.497z",
    transform: "translate(3342.323 1369.12)",
    style: {
      fill: "#6f6571"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45739",
    d: "M-2120.25 422.062h3.093a7.607 7.607 0 0 1 1.367 1.289.176.176 0 0 1 .039.211h-3.094a7.613 7.613 0 0 1-1.366-1.287.178.178 0 0 1-.039-.213z",
    transform: "translate(3124.15 1435.258)",
    style: {
      fill: "#ebe9eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45740",
    d: "m-2162.365 423.548-.01-.748a.6.6 0 0 1 .008-.756h1.591a7.609 7.609 0 0 1 1.366 1.288.176.176 0 0 1 .04.211z",
    transform: "translate(3162.428 1435.273)",
    style: {
      fill: "#ebe9eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45741",
    d: "m-2142.643 423.564-1.406-1.5h2.249l1.406 1.5z",
    transform: "translate(3145.701 1435.254)",
    style: {
      fill: "#d9d7da"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45742",
    d: "m-2085.67 423.56-1.406-1.5h2.249l1.406 1.5z",
    transform: "translate(3094.07 1435.258)",
    style: {
      fill: "#d9d7da"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45743",
    d: "M-2234.5 392.166q0 .378-.007.756h-6.087a.87.87 0 0 1-.144-.618v-2.368c0-.578-.035-.6-.6-.618a1.121 1.121 0 0 1-.757-.144.325.325 0 0 1 0-.091c1.464 0 2.928-.011 4.393 0a3.135 3.135 0 0 1 3.202 3.083z",
    transform: "translate(3234.56 1465.151)",
    style: {
      fill: "#d9d7da"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45744",
    d: "m-2517.354 375.7-.07.01h-.281c-1 0-1.222-.234-1.222-1.248v-9.261a3.086 3.086 0 0 1 1.564-.155q.002 5.329.009 10.654z",
    transform: "translate(3485.437 1486.949)",
    style: {
      fill: "#857e86"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45745",
    d: "M-2482.163 381.219h2.807c.569 0 .929.3.937.759s-.331.778-.914.783q-2.877.021-5.755 0c-.625 0-.949-.316-.928-.809.02-.47.351-.73.952-.733.964-.003 1.934 0 2.901 0z",
    transform: "translate(3455.609 1472.271)",
    style: {
      fill: "#5d5360"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45746",
    d: "M-2482.263 446.182h2.854c.578 0 .936.285.956.74.021.473-.332.8-.941.8q-2.854.017-5.708 0c-.572 0-.883-.24-.942-.65-.074-.522.271-.885.88-.892.964-.005 1.934.002 2.901.002z",
    transform: "translate(3455.643 1413.4)",
    style: {
      fill: "#5d5360"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45747",
    d: "M-2482.257 415.417h-2.854c-.585 0-.911-.287-.9-.773.008-.465.322-.736.888-.737q2.9-.007 5.8 0c.585 0 .917.293.907.77s-.344.739-.94.741c-.967.001-1.934-.001-2.901-.001z",
    transform: "translate(3455.605 1442.651)",
    style: {
      fill: "#5d5360"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45748",
    d: "M-2242.054 390.019c.372 0 .745.016 1.115-.006.314-.018.4.111.392.406-.013 1.116-.006 2.232-.006 3.348h-1.5l-.001-3.748z",
    transform: "translate(3234.518 1464.302)",
    style: {
      fill: "#c7c4c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45749",
    d: "M-2427.528 527.808c.233 0 .466-.006.7 0a.73.73 0 0 1 .781.689.717.717 0 0 1-.677.8 10.992 10.992 0 0 1-1.674 0 .7.7 0 0 1-.659-.806.714.714 0 0 1 .785-.678c.247-.013.496-.005.744-.005z",
    transform: "translate(3403.991 1339.426)",
    style: {
      fill: "#857e86"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogue1);
export default __webpack_public_path__ + "static/media/catalogue1.98c3c9626cb162ab18211ad8a30e3d2e.svg";
export { ForwardRef as ReactComponent };